import {Link} from 'react-router-dom';
// import {useIsFetching, useIsMutating} from '@tanstack/react-query';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
// import {useLogoutContext} from './LogoutContext';
import {Color} from '../../common/theme';

export const AppBar = () => {
    // const {logout} = useLogoutContext();

    // const handleLogout = () => {
    //     logout();
    // };

    const currentURLPath = window.location.href.split('/');
    const isDashboardScreen = currentURLPath[currentURLPath.length - 1] === 'dashboard-screen';
    // const isHomeScreen = currentURLPath[currentURLPath.length - 1] === '';
    const isWebsiteScreen = window.location.host.split('.').length === 3;

    if (isDashboardScreen || isWebsiteScreen) {
        return null;
    } else {
        return (
            <MuiAppBar
                position='fixed'
                sx={{backgroundColor: Color.APPBAR_GREEN, zIndex: (theme) => theme.zIndex.drawer + 1}}>
                <Toolbar disableGutters sx={{paddingLeft: 2, paddingRight: 2}}>
                    <Box sx={{flexGrow: 1, display: {md: 'flex'}}}>
                        <Link to='/'>
                            <div className='flex items-center'>
                                {/* <UdaanIcon /> */}
                                <Typography
                                    style={{
                                        fontFamily: 'Poppins',
                                        fontWeight: 700,
                                    }}
                                    variant='h6'
                                    noWrap
                                    component='div'>
                                    Socialmart
                                </Typography>
                            </div>
                        </Link>
                    </Box>
                </Toolbar>
            </MuiAppBar>
        );
    }
};
